import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30cbf81b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=30cbf81b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cbf81b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30cbf81b')) {
      api.createRecord('30cbf81b', component.options)
    } else {
      api.reload('30cbf81b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=30cbf81b&scoped=true", function () {
      api.rerender('30cbf81b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FromList/index.vue"
export default component.exports